import {figmaElement} from "../figma-tree";
type ArchiveButtonProps = {
  className?: string;
  label?: string;
  state?: "Default";
  style?: "Primary" | "Secondary";
};

function ArchiveButton({ className, label = "强制通过", state = "Default", style = "Primary" }: ArchiveButtonProps) {
  const isSecondaryAndDefault = style === "Secondary" && state === "Default";
  return (
    <div className={className || `border-solid content-stretch flex gap-[var(--archive-space-8,8px)] h-[44px] items-center justify-center p-[var(--archive-space-8,8px)] relative rounded-[var(--archive-radius-4,4px)] w-[104px] ${isSecondaryAndDefault ? "border border-[var(--action-secondary,#626b78)]" : "border-[1.5px] border-[var(--archive-action-primary,#29465b)]"}`} id={isSecondaryAndDefault ? "node-8_13" : "node-8_5"}>
      {style === "Primary" && state === "Default" && (
        <p className="[word-break:break-word] font-['Noto_Sans_SC:Medium'] font-medium leading-[24px] relative shrink-0 text-[14px] text-[color:var(--archive-action-primary,#29465b)] whitespace-nowrap" data-node-id="8:6">
          {label}
        </p>
      )}
      {isSecondaryAndDefault && (
        <p className="[word-break:break-word] font-['Noto_Sans_SC:Medium'] font-medium leading-[24px] relative shrink-0 text-[14px] text-[color:var(--action-secondary,#626b78)] whitespace-nowrap" data-node-id="8:14">
          {label}
        </p>
      )}
    </div>
  );
}

export default function Component112() {
  return (
    <div className="bg-[var(--archive-bg-surface,white)] border border-[var(--archive-border-default,#e1e5eb)] border-solid content-stretch flex flex-col gap-[var(--archive-space-16,16px)] items-start overflow-clip p-[var(--archive-space-24,24px)] relative rounded-[var(--archive-radius-8,8px)] size-full" data-node-id="397:5472" data-name="112 / 我的申请 · 已提醒审核">
      <p className="[word-break:break-word] font-['Noto_Sans_SC:Bold'] font-bold leading-[28px] relative shrink-0 text-[20px] text-[color:var(--archive-text-primary,#20242c)] w-[512px]" data-node-id="397:5473">
        已提醒审核
      </p>
      <p className="[word-break:break-word] font-['Noto_Sans_SC:Regular'] font-normal leading-[24px] relative shrink-0 text-[14px] text-[color:var(--archive-text-primary,#20242c)] w-[512px]" data-node-id="397:5474">
        已通知归档负责人，请耐心等待审核。
      </p>
      <div className="content-stretch cursor-pointer flex h-[44px] items-center justify-between overflow-clip p-[var(--archive-space-0,0px)] relative shrink-0 w-full" data-node-id="397:5475" data-name="Actions">
        <ArchiveButton className="border-[1.5px] border-[var(--archive-action-primary,#29465b)] border-solid content-stretch flex gap-[var(--archive-space-8,8px)] h-[44px] items-center justify-center p-[var(--archive-space-8,8px)] relative rounded-[var(--archive-radius-4,4px)] shrink-0 w-[128px]" label="知道了" />
        <ArchiveButton className="border border-[var(--action-secondary,#626b78)] border-solid content-stretch flex gap-[var(--archive-space-8,8px)] h-[44px] items-center justify-center p-[var(--archive-space-8,8px)] relative rounded-[var(--archive-radius-4,4px)] shrink-0 w-[144px]" label="查看进度" style="Secondary" />
      </div>
    </div>
  );
}
